import { SET_REGISTER_ITEM_TYPE_KIND } from "../actions/types";

const initialState = {
  registerItemTypeKind: [],
  lastDomainId: null,
};

export default function registerItemTypeKindReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_REGISTER_ITEM_TYPE_KIND: {
      return {
        ...state,
        registerItemTypeKind: action.payload.data,
        lastDomainId: action.payload.domainId,
      };
    }
    default:
      return state;
  }
}
